const qaFirebaseConfig = {
  apiKey: "AIzaSyCzopGHiD7DNIu1HviB5-k6kMG4N4snbPs",
  authDomain: "articulearn-qa.firebaseapp.com",
  projectId: "articulearn-qa",
  storageBucket: "articulearn-qa.appspot.com",
  messagingSenderId: "83248458712",
  appId: "1:83248458712:web:382c5025fe80052ab960ad",
  databaseURL: "https://articulearn-qa-default-rtdb.firebaseio.com/",
};

const prodFirebaseConfig = {
  apiKey: "AIzaSyBIZjNqrU-g7hxHEW--AgQPqa8VMnL0cRU",
  authDomain: "ArticuLearnAI.com",
  projectId: "spanishai",
  storageBucket: "spanishai.appspot.com",
  messagingSenderId: "258707100674",
  appId: "1:258707100674:web:51d5729482d6348d51c31b",
  databaseURL: "https://spanishai-default-rtdb.firebaseio.com/",
};

// Prod requires explicit opt-in via VUE_APP_FIREBASE_ENV. We accept "prod"
// (our canonical value, matching .firebaserc) or "production" (the Node
// convention) so a developer typing the more familiar spelling doesn't silently
// fall through to QA. Anything else (QA builds, dev server, ad-hoc
// `npm run build`) gets the QA config — failing closed means a stray
// NODE_ENV=production in someone's shell can't ship prod config to QA.
// Note: VUE_APP_* env vars are inlined by webpack at build time, so the choice
// below is baked into the bundle. Changing the env var at runtime has no effect.
const isProdEnv = process.env.VUE_APP_FIREBASE_ENV === "prod"
  || process.env.VUE_APP_FIREBASE_ENV === "production";
const firebaseConfig = isProdEnv ? prodFirebaseConfig : qaFirebaseConfig;

export default firebaseConfig;
